import { gql } from "@apollo/client"

export const GET_PROMPT_CREATION_INFO = gql`
    query getPromptCreationInfo {
        availableLanguages {
            code
            name
            id
            voices {
                id
                name
                engine
            }
        }
        generateFileName {
            fileName
        }
        getAudioFormats {
            id
            name
            sampleRate
            encoding
            type
        }
    }
`
